import { useState } from 'react';
import Swal from 'sweetalert2';

function getCsrfToken() {
  const match = document.cookie.match(/(?:^|; )csrftoken=([^;]*)/);
  return match ? decodeURIComponent(match[1]) : null;
}

export const useForgetPassword = () => {
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const changePassword = async (password, key) => {
    setIsLoading(true);
    setError(null);

    const headers = { 'Content-Type': 'application/json' };
    const csrfToken = getCsrfToken();
    if (csrfToken) {
      headers['X-CSRFToken'] = csrfToken;
    }

    try {
      const response = await fetch('/api/authenticate/forgetpassword/', {
        method: 'POST',
        headers,
        credentials: 'same-origin',
        body: JSON.stringify({ key, password }),
      });

      if (!response.ok) {
        throw new Error('Password reset failed');
      }

      Swal.fire({
        title: 'Password Changed successfully',
        text: 'You can login now',
        width: 600,
        icon: 'success',
        padding: '3em',
        background: '#fff',
        backdrop: `
          rgba(0,0,123,0.4)
          url("https://media.tenor.com/-AyTtMgs2mMAAAAi/nyan-cat-nyan.gif")
          left bottom
          no-repeat
        `,
      }).then((result) => {
        if (result.isConfirmed) {
          window.location.href = '/login';
        }
      });
    } catch (e) {
      Swal.fire({
        title: 'Something went wrong',
        text: 'Please contact the developers.',
        icon: 'error',
        confirmButtonText: 'OK',
      }).then((result) => {
        if (result.isConfirmed) {
          window.location.href = '/team';
        }
      });
      setError(true);
    } finally {
      setIsLoading(false);
    }
  };

  return { changePassword, isLoading, error };
};
